import { Chip } from '@mui/material';
import { ITag } from '../Interfaces/ITag';

interface TagChipProps {
    tag: ITag;
    size?: 'small' | 'medium';
    onDelete?: () => void;
}

// Wählt anhand der Hintergrundfarbe automatisch helle oder dunkle Schrift (Kontrast).
const getContrastText = (hex: string): string => {
    const normalized = hex.replace('#', '');
    const full = normalized.length === 3
        ? normalized.split('').map((c) => c + c).join('')
        : normalized;
    if (full.length !== 6) {
        return '#ffffff';
    }
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#1f2520' : '#ffffff';
};

const TagChip: React.FC<TagChipProps> = ({ tag, size = 'small', onDelete }) => {
    const textColor = getContrastText(tag.color);
    return (
        <Chip
            label={tag.name}
            size={size}
            onDelete={onDelete}
            sx={{
                backgroundColor: tag.color,
                color: textColor,
                fontWeight: 600,
                borderRadius: 999,
                border: '1px solid rgba(20, 35, 25, 0.12)',
                '& .MuiChip-deleteIcon': {
                    color: textColor,
                    opacity: 0.7,
                    '&:hover': { opacity: 1, color: textColor },
                },
            }}
        />
    );
};

export default TagChip;
